const LANGUAGE_LABELS = {
  sv: 'Svenska',
  nb: 'Norsk',
  da: 'Dansk',
  en: 'English',
}

const LOCALES = ['sv', 'nb', 'da', 'en']

const createFlagDataUri = (svg) => `data:image/svg+xml,${encodeURIComponent(svg)}`

const LANGUAGE_FLAGS = {
  sv: createFlagDataUri('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 16"><rect width="24" height="16" fill="#005293"/><rect x="7" width="4" height="16" fill="#fecb00"/><rect y="6" width="24" height="4" fill="#fecb00"/></svg>'),
  nb: createFlagDataUri('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 16"><rect width="24" height="16" fill="#ba0c2f"/><rect x="6" width="4" height="16" fill="#fff"/><rect y="6" width="24" height="4" fill="#fff"/><rect x="7" width="2" height="16" fill="#00205b"/><rect y="7" width="24" height="2" fill="#00205b"/></svg>'),
  da: createFlagDataUri('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 16"><rect width="24" height="16" fill="#c60c30"/><rect x="6" width="4" height="16" fill="#fff"/><rect y="6" width="24" height="4" fill="#fff"/></svg>'),
  en: createFlagDataUri('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 30"><defs><clipPath id="a"><rect width="60" height="30"/></clipPath></defs><g clip-path="url(#a)"><rect width="60" height="30" fill="#012169"/><path d="M0 0l60 30M60 0L0 30" stroke="#fff" stroke-width="6" stroke-linecap="square"/><path d="M0 0l60 30M60 0L0 30" stroke="#c8102e" stroke-width="4" stroke-linecap="square"/><rect x="24" width="12" height="30" fill="#fff"/><rect y="12" width="60" height="6" fill="#fff"/><rect x="26" width="8" height="30" fill="#c8102e"/><rect y="13" width="60" height="4" fill="#c8102e"/></g></svg>')
}

const normalizeOption = (value, label) => {
  if (!value) return null
  const optionLabel = label || LANGUAGE_LABELS[value] || value.toUpperCase()
  return { value, label: optionLabel }
}

export const getLanguageOptions = (shop) => {
  const options = []
  const pushOption = (value, label) => {
    const normalized = normalizeOption(value, label)
    if (!normalized) return
    if (options.find(option => option.value === normalized.value)) return
    options.push(normalized)
  }

  LOCALES.forEach(locale => pushOption(locale))
  if (shop?.locale)
    pushOption(shop.locale)

  return options
}

export const getFlagStyle = (locale) => {
  const flag = LANGUAGE_FLAGS[locale]
  if (!flag) return undefined
  return { backgroundImage: `url("${flag}")` }
}

export {
  LANGUAGE_LABELS,
  LOCALES,
  LANGUAGE_FLAGS
}
